// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import CacheBuster from './components/CacheBuster';
import App from './App';
import './styles.css';

// Версия приложения - меняйте вручную при каждом обновлении
const APP_VERSION = '1.0.1';

// Компонент загрузки
const LoadingComponent = () => (
  <div className="loading-container">
    <div className="loading-spinner"></div>
    <div>Проверка обновлений...</div>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <CacheBuster
      currentAppVersion={APP_VERSION}
      loadingComponent={<LoadingComponent />}
    >
      <App />
    </CacheBuster>
  </React.StrictMode>
);